import { apiRequest } from '@reservamos/js-api-client';
import { MercadoPagoBasisTheoryPollingError } from '@/services/mercadoPagoBasisTheoryPayment';

/** Read through the configured SDK transport, retaining only safe error categories. */
export async function readMercadoPagoPurchase(
  token: string,
  paymentId?: string,
  signal?: AbortSignal,
): Promise<unknown> {
  const client: unknown = apiRequest;
  if (
    typeof client !== 'object' ||
    client === null ||
    !('get' in client) ||
    typeof client.get !== 'function'
  ) {
    throw new MercadoPagoBasisTheoryPollingError('request_failed');
  }
  const endpoint = `purchases/${encodeURIComponent(token)}${
    paymentId === undefined ? '' : `/payments/${encodeURIComponent(paymentId)}`
  }`;
  try {
    const response: unknown = await client.get(endpoint, { signal, skipErrorMapping: true });
    return response;
  } catch (error: unknown) {
    if (signal?.aborted) throw new MercadoPagoBasisTheoryPollingError('aborted');
    const status =
      typeof error === 'object' && error !== null && 'code' in error ? error.code : undefined;
    const retryable =
      error instanceof TypeError ||
      (typeof status === 'number' &&
        (status === 408 || status === 429 || (status >= 500 && status <= 599)));
    throw new MercadoPagoBasisTheoryPollingError('request_failed', retryable);
  }
}
